import axios from "axios";

const API_URL = process.env.REACT_APP_HOST_API;

class AgendaService {
    
    /**
     * Lista todos os agendamentos
     * @returns {Promise} Lista de agendamentos
     */
    async getAll() {
        const url = `${API_URL}/v1/agenda`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getByEquipe(idEquipe) {
        const url = `${API_URL}/v1/agenda/equipe/${idEquipe}`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async delete(id) {
        const url = `${API_URL}/v1/agenda/${id}`;
        return axios.delete(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    /**
     * Busca um agendamento pelo UUID de acesso externo (sem autenticação)
     * @param externalAccessUuid UUID de acesso externo
     * @returns {Promise} Agendamento encontrado
     */
    async getByExternalUuid(externalAccessUuid) {
        const url = `${API_URL}/v1/publico/agenda/external/${externalAccessUuid}`;
        return axios.get(url);
    }

    /**
     * Cria uma nova agenda
     * @param agenda Dados da agenda
     * @returns {Promise} Agenda criada
     */
    async bloquear(agenda) {
        const url = `${API_URL}/v1/agenda/bloquear`;
        return axios.post(url, agenda, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }
}

export default new AgendaService();
